export class GetOrderById {
    public static readonly type = '[OrdersItem] Get order by id';
    constructor(public id: string) {
    }
}


